import { gql } from "apollo-boost"

export const SAVE_PARCEL_EVENT = gql`
  mutation saveCustomParcelEvent($payload: SaveParcelEventInput!) {
    saveCustomParcelEvent(payload: $payload)
  }
`
